// Environment configuration with validation

interface Config {
  apiUrl: string;
}

function validateConfig(): Config {
  const viteApiUrl = (import.meta as any).env?.VITE_API_URL;

  // If VITE_API_URL is explicitly set, use it
  if (viteApiUrl) {
    const normalizedUrl = viteApiUrl.replace(/\/$/, '');
    console.log(`[Config] Using VITE_API_URL: ${normalizedUrl}`);
    return { apiUrl: normalizedUrl };
  }

  // Check if we're running on localhost
  const isLocalhost = typeof window !== 'undefined' && (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
  );

  if (isLocalhost) {
    console.log('[Config] Localhost detected, using http://localhost:3001');
    return { apiUrl: 'http://localhost:3001' };
  }

  // Production: Use relative URLs (same domain as frontend)
  console.log('[Config] Production mode, using relative URLs (same domain)');
  return { apiUrl: '' };
}

// Validate and export config
export const config = validateConfig();

// Export for convenience
export const API_URL = config.apiUrl;
